import React from 'react';
import { createIcon } from '@eds/icon';

export const SaveIcon = createIcon(
  <path d="M17.3333 2.39999H4.53333C3.34933 2.39999 2.39999 3.35999 2.39999 4.53333V19.4667C2.39999 20.64 3.34933 21.6 4.53333 21.6H19.4667C20.64 21.6 21.6 20.64 21.6 19.4667V6.66666L17.3333 2.39999ZM19.4667 19.4667H4.53333V4.53333H16.448L19.4667 7.55199V19.4667ZM12 12C10.2293 12 8.79999 13.4293 8.79999 15.2C8.79999 16.9707 10.2293 18.4 12 18.4C13.7707 18.4 15.2 16.9707 15.2 15.2C15.2 13.4293 13.7707 12 12 12ZM5.59999 5.59999H15.2V9.86666H5.59999V5.59999Z" />,
  'SaveIcon'
);
